<template>
  <!-- 分页 组件 -->
  <div class="pagination_content">
    <div class="footerLeftPage">
      每页显示条数
      <p
        v-for="(item, index) in pageData"
        :key="index"
        :class="form.page.pageSize == pageData[index] ? 'p_active' : ''"
        @click="pageSizeFn(item)"
      >
        {{ item }}
      </p>
    </div>
    <el-pagination
      background
      :current-page="form.page.page"
      @current-change="pageSizeChange"
      :page-size="form.page.pageSize"
      :pager-count="5"
      layout="prev, pager, next,jumper"
      :total="totalnum"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "pagination_content",
  props: {
    paddingIsShow: {
      default: "false"
    },
    pages: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      form: {
        page: {
          page: 1, //当前第几页
          pageSize: 10, //每页几条
          pages: 20, //总共条数
          dotdel_: 3
        }
      },
      pageData: [10, 20, 30]
    };
  },
  computed: {
    totalnum() {
      return this.pages;
    }
  },
  methods: {
    go_top() {
      let ispeed = Math.floor(-this.scrollTop / 5);
      document.documentElement.scrollTop = document.body.scrollTop =
        this.go_top + ispeed;
    },
    pageSizeChange(val) {
      this.form.page.page = Number(val);
      this.emit_fn();
      this.go_top();
    },
    pageSizeFn(res) {
      this.form.page.pageSize = Number(res);
      this.form.page.page = 1;
      this.emit_fn();
      this.go_top();
    },
    emit_fn() {
      this.$emit("no-change-pagination", {
        data: this.form.page,
        messages: {
          page: "当前第几页",
          pageSize: "每页几条",
          pages: "总共条数"
        }
      });
    }
  },
  mounted() {
    // this.form.page.pages = this.pages
    setTimeout(() => {
      console.log(this.pages);
    }, 5000);
    let elIconArrowLeft = document.getElementsByClassName("btn-prev")[0];
    let elIconArrowRight = document.getElementsByClassName("btn-next")[0];
    elIconArrowLeft.innerHTML = "上一页";
    elIconArrowRight.innerHTML = "下一页";
    console.log(elIconArrowLeft, elIconArrowRight);
  }
};
</script>

<style scoped lang="less">
.pagination_content {
  padding: 44px 40px 20px 40px;
  display: flex;
  justify-content: space-between;
  .footerLeftPage {
    width: 210px;
    height: 30px;
    display: flex;
    align-items: center;
    p {
      width: 30px;
      height: 30px;
      font-size: 12px;
      font-weight: 500;
      color: rgba(204, 204, 204, 1);
      line-height: 30px;
      border-radius: 4px;
      text-align: center;
      margin-left: 10px;
      cursor: pointer;
      border: 1px solid rgba(204, 204, 204, 1);
    }
    .p_active {
      background-color: rgba(21, 47, 106, 1);
      border: 1px solid rgba(21, 47, 106, 1);
      color: #ffffff;
    }
  }
}
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: rgba(21, 47, 106, 1) !important;
  border: none !important;
  color: #fff !important;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: rgba(21, 47, 106, 1) !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  background-color: rgba(21, 47, 106, 1) !important;
  border: none !important;
  color: #fff !important;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  /* background-color:none!important;  */
  background: none !important;
  border: 1px solid rgba(204, 204, 204, 1) !important;
  border-radius: 4px !important;
}
/* .el-pager .active{
  background:red
} */
.el-pager li {
  height: 30px !important;
  line-height: 30px !important;
  /* main-width:30px; */
}
.btn-prev,
.btn-next {
  height: 30px !important;
  font-size: 12px !important;
  padding: 0 10px !important;
  /* color:#000000; */
}
</style>



// WEBPACK FOOTER //
// src/components/common/pagination/index.vue